module.exports = __webpack_public_path__ + "static/media/MAIL.726d2c88.svg";